import { render, staticRenderFns } from "./ContentDiscoveryConvo.vue?vue&type=template&id=205fbec2&"
import script from "./ContentDiscoveryConvo.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryConvo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports